import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { VesselModel } from 'shared/models';
import { CompanyInfo } from 'shared/models';

@Component({
    selector: 'app-vessel-tag-print',
    templateUrl: './vessel-tag-print.component.html',
    styleUrls: ['./vessel-tag-print.component.css'],
    standalone: false
})
export class VesselTagPrintComponent implements OnInit {
  ApiUrl = environment.Api_Url;
  VesselId: number = 0;
  Vessel: VesselModel = new VesselModel();
  CompanyName: string = '';
  isLoading: boolean = true;
  private route$: Subscription = new Subscription();
  count: number = 0;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.CompanyName = CompanyInfo.CompanyName;
    this.route$ = this.route.params.subscribe((params: Params) => {
      this.VesselId = params['id'];
      this.loadVesselData();
    });
  }

  loadVesselData() {
    // Load all vessels and find the one we need
    let url = this.ApiUrl + 'vessel/getallvessels';
    this.http.get<VesselModel[]>(url).subscribe(res => {
      this.Vessel = res.find(v => v.VesselId == this.VesselId) || new VesselModel();
      this.isLoading = false;
      // Auto-print after data loads
      setTimeout(() => {
        window.print();
        window.onafterprint = close;
      }, 500);
    }, err => {
      this.count++;
      if (this.count < 2) { this.loadVesselData(); }
    });
  }

  ngOnDestroy() {
    this.route$.unsubscribe();
  }
}
